import constants from '_store/_constants/charges.constants';

const initialState = {
  charges: [],
  total: 0,
  paymentGateways: [],
  paymentMethods: [],
  isCreating: false,
  isEditing: false,
  loading: false,
  error: null,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  deleteId: null,
  chargesSummary: [],
  summaryLoading: false,
  summaryError: null,
  currentCharge: null,
  fetchChargeLoading: false,
  fetchChargeError: null,
  dashboardData: null,
  dashboardLoading: false,
  dashboardError: null,
};

export function companyCharges(state = initialState, action) {
  switch (action.type) {
    case constants.CHARGES_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case constants.CHARGES_FETCH_SUCCESS:
      const { total, data } = action.payload;

      return {
        ...state,
        loading: false,
        charges: data,
        total,
        error: null,
      };
    case constants.CHARGES_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };

    // Create charge reducers
    case constants.CHARGE_CREATE_REQUEST:
      return {
        ...state,
        createLoading: true,
        error: null,
      };
    case constants.CHARGE_CREATE_SUCCESS:
      return {
        ...state,
        createLoading: false,
        charges: [...state.charges, action.payload],
        error: null,
      };
    case constants.CHARGE_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        error: action.payload.message,
      };

    // Update charge reducers
    case constants.CHARGE_UPDATE_REQUEST:
      return {
        ...state,
        updateLoading: true,
        error: null,
      };
    case constants.CHARGE_UPDATE_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        charges: state.charges.map(charge =>
          charge.id === action.payload.id ? action.payload : charge,
        ),
        error: null,
      };
    case constants.CHARGE_UPDATE_FAILURE:
      return {
        ...state,
        updateLoading: false,
        error: action.payload.message,
      };

    // Delete charge reducers
    case constants.CHARGE_DELETE_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        deleteId: action.payload.id,
        error: null,
      };
    case constants.CHARGE_DELETE_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        deleteId: null,
        charges: state.charges.filter(charge => charge.id !== action.payload.id),
        error: null,
      };
    case constants.CHARGE_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteId: null,
        error: action.payload.message,
      };

    // Charges summary reducers
    case constants.CHARGES_SUMMARY_REQUEST:
      return {
        ...state,
        summaryLoading: true,
        summaryError: null,
      };
    case constants.CHARGES_SUMMARY_SUCCESS:
      return {
        ...state,
        summaryLoading: false,
        chargesSummary: action.payload,
        summaryError: null,
      };
    case constants.CHARGES_SUMMARY_FAILURE:
      return {
        ...state,
        summaryLoading: false,
        summaryError: action.payload?.message || 'Erro ao carregar resumo de cobranças',
      };

    // Fetch charge by ID reducers
    case constants.FETCH_CHARGE_BY_ID_REQUEST:
      return {
        ...state,
        fetchChargeLoading: true,
        fetchChargeError: null,
      };
    case constants.FETCH_CHARGE_BY_ID_SUCCESS:
      return {
        ...state,
        fetchChargeLoading: false,
        currentCharge: action.payload.charges,
        fetchChargeError: null,
      };
    case constants.FETCH_CHARGE_BY_ID_FAILURE:
      return {
        ...state,
        fetchChargeLoading: false,
        fetchChargeError: action.payload.message,
      };

    case constants.FETCH_PUBLIC_CHARGE_BY_ID_REQUEST:
      return {
        ...state,
        fetchChargeLoading: true,
        fetchChargeError: null,
      };
    case constants.FETCH_PUBLIC_CHARGE_BY_ID_SUCCESS:
      return {
        ...state,
        fetchChargeLoading: false,
        currentCharge: action.payload.charges,
        fetchChargeError: null,
      };
    case constants.FETCH_PUBLIC_CHARGE_BY_ID_FAILURE:
      return {
        ...state,
        fetchChargeLoading: false,
        fetchChargeError: action.payload.message,
      };
    case constants.CHARGES_DASHBOARD_FETCH_REQUEST:
      return {
        ...state,
        dashboardLoading: true,
        dashboardError: null,
      };
    case constants.CHARGES_DASHBOARD_FETCH_SUCCESS:
      return {
        ...state,
        dashboardData: action.payload,
        dashboardLoading: false,
        dashboardError: null,
      };
    case constants.CHARGES_DASHBOARD_FETCH_FAILURE:
      return {
        ...state,
        dashboardLoading: false,
        dashboardError: action.payload?.message || 'Erro ao carregar dashboard',
      };

    default:
      return state;
  }
}
